var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-modal-contents", {
        ref: "modal_contents_agree",
        scopedSlots: _vm._u([
          {
            key: "close",
            fn: function () {
              return [_c("div")]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title mt-30 pl-3 " }, [
                  _c("div", { staticClass: "h2_title" }, [
                    _vm._v("Условия использования персональных данных"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _c("div", { domProps: { innerHTML: _vm._s(_vm.terms) } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-30" }, [
                    _c(
                      "button",
                      {
                        staticClass: "px-30 btn-red ",
                        on: {
                          click: function ($event) {
                            return _vm.$refs.modal_contents_agree.modal_open()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        Прочитал\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: " form-contract",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c("div", { staticClass: "row mx-0 my-0" }, [
            _c("div", { staticClass: "col-12 col-md-6 col-lg-6 p-md-2" }, [
              _c("h2", { staticClass: "formNew_h2" }, [
                _vm._v(
                  "\n                    Оставьте заявку на коммерческое предложение\n                "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-6 col-lg  p-0" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "form-contract__item position-relative" },
                  [
                    _c("v-text-field", {
                      staticClass: "form-contract__input",
                      attrs: { rules: _vm.nameRules, id: "name" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n                                ФИО *\n                            "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.name,
                        callback: function ($$v) {
                          _vm.name = $$v
                        },
                        expression: "name",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mx-0 my-0" }, [
                _c("div", { staticClass: "col-12 col-md-6 " }, [
                  _c(
                    "div",
                    { staticClass: "form-contract__item" },
                    [
                      _c("v-text-field", {
                        staticClass: "form-contract__input",
                        attrs: {
                          rules: _vm.emailRules,
                          oninput: "this.value = this.value.trim()",
                          id: "email",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _vm._v(
                                  "\n                                    Электронная почта *\n                                "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.email,
                          callback: function ($$v) {
                            _vm.email = $$v
                          },
                          expression: "email",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-contract__item" },
                    [
                      _c("v-text-field", {
                        staticClass: " form-contract__input",
                        attrs: {
                          rules: _vm.telRules,
                          id: "tel",
                          oninput:
                            "this.value = this.value.replace(/[^\\d]/g,'');this.value = this.value.slice(0,10); ",
                          max: "20",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _vm._v(
                                  "\n                                    Телефон *\n                                "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.tel,
                          callback: function ($$v) {
                            _vm.tel = $$v
                          },
                          expression: "tel",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 " }, [
                _c(
                  "div",
                  { staticClass: "form-contract__item role" },
                  [
                    _c("v-select", {
                      staticClass: "form-contract__input",
                      attrs: {
                        items: _vm.product_types,
                        "item-value": "id",
                        label: "Тип продукции *",
                        required: "",
                        rules: _vm.requiredRules,
                        "append-icon": "mdi mdi-chevron-down",
                        id: "product_type",
                        "menu-props": { contentClass: "wrapp_role" },
                        "return-object": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "item",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(item.name) +
                                  "\n                            "
                              ),
                            ]
                          },
                        },
                        {
                          key: "selection",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(item.name) +
                                  "\n                            "
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.product_type,
                        callback: function ($$v) {
                          _vm.product_type = $$v
                        },
                        expression: "product_type",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mx-0 my-0" }, [
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-contract__item position-relative" },
                    [
                      _c("v-text-field", {
                        staticClass: "form-contract__input",
                        attrs: {
                          rules: _vm.requiredRules,
                          id: "product_weight",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _vm._v(
                                  "\n                                    Вес продукта *\n                                "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.product_weight,
                          callback: function ($$v) {
                            _vm.product_weight = $$v
                          },
                          expression: "product_weight",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-contract__item position-relative" },
                    [
                      _c("v-text-field", {
                        staticClass: "form-contract__input",
                        attrs: {
                          rules: _vm.requiredRules,
                          id: "product_color",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _vm._v(
                                  "\n                                    Цвет продукта *\n                                "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.product_color,
                          callback: function ($$v) {
                            _vm.product_color = $$v
                          },
                          expression: "product_color",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-md-12 pb-3 px-3 pt-3" }, [
                _c("div", {
                  staticClass: "w-100 mt-30",
                  class: _vm.captchaPassed ? "" : "error-captcha",
                  attrs: { id: "captcha-container" },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-contract__item  mt-30" },
                  [
                    _c("v-checkbox", {
                      attrs: {
                        rules: [
                          function (v) {
                            return !!v || "Это обязательный пункт"
                          },
                        ],
                        required: "",
                        color: "red",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "customLabelForm" }, [
                                _vm._v(
                                  "\n                                    Я выражаю согласие с\n                                    "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "javascript:void(0);",
                                      target: "_blank",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$refs.modal_contents_agree.modal_open(
                                          "scroll_false"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        условиями использования\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  "\n                                    моих персональных данных для обработки данного обращения ООО «Компания Нова\n                                    Ролл» (ИНН 5038050970, адрес: 141206, Московская область, г. Пушкино, Кудринское\n                                    шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю согласие с\n                                    "
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass: "position-relative zi-1",
                                    attrs: { href: _vm.policy },
                                    on: {
                                      click: function ($event) {
                                        return _vm.linkOpen(_vm.policy)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        Политикой конфиденциальности\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  " и\n                                    "
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass: "position-relative zi-1",
                                    attrs: { href: _vm.agreement },
                                    on: {
                                      click: function ($event) {
                                        return _vm.linkOpen(_vm.agreement)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        Пользовательским соглашением.\n                                    "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.checkbox,
                        callback: function ($$v) {
                          _vm.checkbox = $$v
                        },
                        expression: "checkbox",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-checkbox", {
                      staticClass: "mt-0",
                      attrs: { color: "red" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "customLabelForm" }, [
                                _vm._v(
                                  "\n                                    Я выражаю согласие на информирование меня о продуктах, акциях, выгодных\n                                    предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206,\n                                    Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2) и\n                                    партнеров.\n                                "
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.consentToInform,
                        callback: function ($$v) {
                          _vm.consentToInform = $$v
                        },
                        expression: "consentToInform",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "btn_form d-flex align-items-center justify-content-start",
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "px-30 btn-red w-mc ",
                            attrs: { disabled: !_vm.valid, type: "button" },
                            on: { click: _vm.sendForm },
                          },
                          [
                            _vm._v(
                              "\n                                Получить коммерческое предложение\n                            "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }